import { AdminReviewPlaceholderPage } from "./AdminReviewPlaceholderPage";

const adminLinks = [
  { to: "/t/:tenantSlug/teacher/admin", label: "管理ホーム" },
  { to: "/t/:tenantSlug/teacher/admin/member-communications", label: "連絡事項" },
  { to: "/t/:tenantSlug/teacher/admin/billing/event-fees", label: "イベント料金設定" }
];

export function AdminEventsPage() {
  return (
    <AdminReviewPlaceholderPage
      title="イベント"
      description="イベント一覧画面のプレースホルダーです。"
      links={adminLinks}
      summary="イベント一覧と編集 UI は次フェーズで実装します。"
      notes={[
        "このページは protected admin shell に移行済みです。",
        "イベント作成・編集は今後の admin event 実装で追加します。",
        "運用イベントの料金はイベント料金設定から確認できます。公開イベント料金とは別の管理領域です。"
      ]}
    />
  );
}
